// extracted by mini-css-extract-plugin
module.exports = {"compatibleWithContainer":"CompatibleTab_compatibleWithContainer__vtyn5","row":"CompatibleTab_row__PWGGS"};